import Entry from "@/interfaces/uniabc/Entry";
import { UniAbcState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State as RootState } from "../state";
import Reference from "@/interfaces/uniabc/Reference";
import Approval from "@/interfaces/uniabc/Approval";

export const mutations = {
  setEntries(state: UniAbcState, payload: Entry[]) {
    state.entries = payload.reduce(
      (obj: { [label: string]: Entry }, e: Entry) => ((obj[e.label] = e), obj),
      {}
    );
  },

  setEntry(state: UniAbcState, payload: Entry) {
    state.entries[payload.label] = payload;
  },

  deleteEntry(state: UniAbcState, payload: Entry) {
    delete state.entries[payload.label];
  },

  setImageUrlOfEntry(
    state: UniAbcState,
    payload: { label: string; imageUrl: string }
  ) {
    //eslint-disable-next-line @typescript-eslint/camelcase
    state.entries[payload.label].image_url = payload.imageUrl;
  },

  setReference(state: UniAbcState, payload: { label: string; ref: Reference }) {
    const refs: Reference[] = state.entries[payload.label].refs;
    const refIndex = refs.findIndex(r => r.key === payload.ref.key);
    if (refIndex >= 0) {
      refs[refIndex] = payload.ref;
    } else {
      refs.push(payload.ref);
    }
  },

  deleteReference(
    state: UniAbcState,
    payload: { label: string; ref: Reference }
  ) {
    const refs: Reference[] = state.entries[payload.label].refs;
    refs.splice(
      refs.findIndex(r => r.key === payload.ref.key),
      1
    );
  },

  setLastLoad(state: UniAbcState, payload: Date) {
    state.lastLoad = payload;
  },

  setFileLastCommitId(state: UniAbcState, payload: string) {
    state.fileLastCommitId = payload;
  },

  setLastEdit(state: UniAbcState, payload: string) {
    state.entries[payload].lastEdit = new Date();
  },

  setApproval(
    state: UniAbcState,
    payload: { label: string; approval: Approval }
  ) {
    state.entries[payload.label].lastApproved = payload.approval;
  }
};

const { commit } = getStoreAccessors<UniAbcState, RootState>("");

export const commitSetEntries = commit(mutations.setEntries);
export const commitSetEntry = commit(mutations.setEntry);
export const commitDeleteEntry = commit(mutations.deleteEntry);
export const commitSetReference = commit(mutations.setReference);
export const commitDeleteReference = commit(mutations.deleteReference);
export const commitSetLastLoad = commit(mutations.setLastLoad);
export const commitSetFLCID = commit(mutations.setFileLastCommitId);
export const commitSetEntryImageUrl = commit(mutations.setImageUrlOfEntry);
export const commitLastEdit = commit(mutations.setLastEdit);
export const commitSetApproval = commit(mutations.setApproval);
